export default class BTemplate
{
	constructor(el)
	{
		this.el = el;
	}

	getElement(parentElement = "div")
	{
		let div = document.createElement(parentElement);
		div.innerHTML = this.el.innerHTML;

		return div;
	}
}
